export default __webpack_public_path__ + "static/media/certifcate2.eac5c276.png";